import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/BookAppointment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/Doctor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/Services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fb1128f6558f0014d288f8/drpals/src/components/dental/Testimonials.tsx");
